import React from 'react'
import { IconsProps } from 'msp-integrations'

const OrganicIcon = (props: IconsProps) => {
  return (
    <svg
      width='36'
      height='36'
      viewBox='0 0 36 36'
      {...props}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d="M18 35.514C8.337 35.514.475 27.657.475 18S8.337.486 18 .486C27.663.486 35.525 8.343 35.525 18S27.663 35.514 18 35.514zm0-33.896C8.961 1.618 1.608 8.967 1.608 18c0 9.033 7.353 16.382 16.392 16.382S34.392 27.033 34.392 18c0-9.033-7.353-16.382-16.392-16.382zm2.197 25.8h-.002c-.257 0-.522-.01-.786-.03a.556.556 0 0 1-.532-.189c-1.961-2.437-2.64-4.946-2.017-7.457.659-2.66 2.736-5.234 6.173-7.65 2.522-1.773 4.823-2.775 4.92-2.817a.564.564 0 0 1 .748.305c1.788 4.338 1.282 10.178-1.203 13.885-1.733 2.586-4.258 3.953-7.301 3.953zm-.234-1.135.233.003h.001c2.648 0 4.847-1.193 6.36-3.45 2.149-3.207 2.677-8.373 1.308-12.271-1.963.952-8.689 4.535-9.906 9.451-.443 1.789-.097 3.599 1.028 5.393.466-1.904 1.879-5.698 6.157-11.055a.567.567 0 0 1 .886.707c-4.722 5.911-5.816 9.843-6.067 11.222zm-6.33-2.349a.566.566 0 0 1-.147-.02c-2.459.032-4.454-1.041-5.754-3.099-1.786-2.827-1.981-7.378-.453-10.585a.567.567 0 0 1 .764-.263c.282.14 6.916 3.488 7.827 8.245.367 1.92-.243 3.782-1.815 5.534a.568.568 0 0 1-.422.188zm.373-1.986c.727-1.15.979-2.331.751-3.523-.668-3.491-5.143-6.287-6.692-7.16-1.112 2.836-.873 6.575.625 8.946.996 1.577 2.484 2.457 4.318 2.562-.177-1.137-.912-3.976-3.968-8.254a.567.567 0 0 1 .923-.658c2.722 3.811 3.696 6.555 4.043 8.087z" />
    </svg>
  )
}

export default OrganicIcon
